/**
 * @value = {date, start_at, slots, participants, timeslots, hold, hold_id}
 */
import {name, mixins, props, data} from './config'
import {parseDateTime, formatDate} from '../../../../../../lib/dates'
import {
  reservationAvailability,
  reservationGetAvailability,
  reservationHold,
  reservationUnHold
} from '../../../../../../services/product'

export default {
  name,
  mixins,
  props,

  data() {
    return {
      hydrating: false,
      innerValue: this.value,
      chosenDate: this.date,
      selectedDate: this.date,
      fields: {
        start_at: this.date,
        participants: this.participants,
        slots: this.participants,
        timeslots: {},
      },
      orderedSlots: [],
      isLoadingSlots: false,
      loadError: '',
      ...data,
    }
  },
  computed: {
    productId() {
      return this.product?.id
    },
    datePicketComponentName() {
      return this.datePickerComponent || 're-date-picker'
    },
    datePickerProps() {
      return this.parseReactiveDataRecursive(this.datePickerAttrs, null, true)
    },
    slotsClass() {
      return [this.timeslotsClasses]
    },
    slotsContainerClass() {
      return [this.timeslotsContainerClasses]
    },
    slotsErrorClass() {
      return [this.timeslotsErrorClasses]
    },
    visibleSlots() {
      const slotsToPop = (this.numConsecutiveSlots || 1) - 1
      let slots = _.clone(this.orderedSlots)
      if (slotsToPop) {
        slots.splice(-slotsToPop)
      }
      return slots
    },
    slots() {
      return _.mapKeys(this.orderedSlots || [], 'id')
    },
    selectedSlots() {
      return _.pickBy(this.slots, 'selected')
    },
    hasDateAndLoading() {
      return !this.isLoadingSlots && this.fields.start_at
    },
    hasVisibleSlots() {
      return this.hasDateAndLoading && !!this.visibleSlots.length
    },
    hasSlots() {
      return this.hasDateAndLoading && !!this.orderedSlots.length
    },
    hasError() {
      return this.hasDateAndLoading && !!this.loadError
    },

  },
  watch: {
    selectedDate: {
      async handler(value, oldValue) {
        if (!this.hydrating) {
          if (value) {
            this.fields.start_at = value
            await this.loadTimeslots(value)
          }
        }
      }
    },
    'fields.timeslots': {
      handler(value, oldValue) {
        this.emit()
      }
    },
    value: {
      deep: true,
      handler(value) {
        this.innerValue = value
      }
    },
    participants(value) {
      this.fields.participants = value
    }
  },
  created() {
    this.setFields()
  },
  methods: {
    watchChosenDate(newValue) {
      if (_.isObject(newValue)) {
        newValue = null
      }
      if (newValue) {
        newValue = ('' + newValue).trim()
        this.selectedDate = newValue
        //this.chosenDate = this.selectedDate
      }
    },
    setFields(force){
      const value = this.innerValue || {}
      if (!_.isEmpty(value) || force) {
        this.hydrating = true
        this.chosenDate = this.selectedDate = value.start_at

        this.fields.start_at = value.start_at
        this.fields.timeslots = value.timeslots
        this.fields.participants = value.participants
        this.fields.slots = value.slots

        this.hydrating = false
      }
    },
    async loadTimeslots() {
      const product_id = this.productId
      const start_at = this.fields.start_at
      this.loadError = null
      this.orderedSlots = []
      if (product_id && start_at) {
        try {
          this.isLoadingSlots = true
          const availability = await reservationGetAvailability({product_id, start_at})
          const slots = availability.available || []
          this.orderedSlots = this.parseSlots(slots)
          if (!this.orderedSlots.length) {
            this.loadError = this.messages.unavailable
          } else {
            const visible = this.visibleSlots
            if (!visible.length) {
              this.loadError = this.messages.unavailable
            }
          }
        } catch (e) {
          this.loadError = this.messages.unavailable
        }
        this.isLoadingSlots = false
      }
    },
    parseSlots(slots) {
      const items = _.sortBy(_.map(slots, item => {
        const date = item.start_at
        const datetime = parseDateTime(date)
        const time = formatDate(datetime, 'h:mm a')
        const timestamp = parseInt(datetime.toSeconds())
        const id = time
        return {
          ...item,
          selected: false,
          processing: false,
          disabled: false,
          valid: true,
          participants: 0,
          holds: null,
          nextId: null,
          prevId: null,
          id,
          datetime,
          time,
          timestamp,
        }
      }), 'timestamp')

      return _.map(items, (item, index) => {
        return {
          ...item,
          nextId: (items[index + 1] || {}).id,
          prevId: (items[index - 1] || {}).id,
        }
      }, {})
    },

    getTimeslotProps(slot, id) {
      const classes = [
        {
          active: slot.selected,
          selected: slot.selected,
          processing: slot.processing,
          disabled: slot.disabled,
          valid: slot.valid,
        },
        this.timeslotAttrs.class
      ]

      return {
        class: classes
      }
    },
    getTimeslotTitleProps(slot, id) {
      const classes = [
        _.get(this.timeslotAttrs, 'title.class'),
      ]
      return {
        class: classes
      }
    },
    getTimeslotTimeProps(slot, id) {
      const classes = [
        _.get(this.timeslotAttrs, 'time.class'),
      ]
      return {
        class: classes
      }
    },
    getTimeslotDetailsProps(slot, id) {
      const classes = [
        _.get(this.timeslotAttrs, 'details.class'),
      ]
      return {
        class: classes
      }
    },
    isTimeslotProcessing(slot, id) {
      return slot.processing
    },
    async toggleSlotSelect(slot) {
      if (slot.disabled || slot.processing) {
        return
      }
      if (slot.selected) {
        await this.unhold(slot)
      } else {
        if (_.size(this.selectedSlots) >= this.maxSlots) {
          this.unholdSelectedSlots()
        }
        await this.hold(slot)
      }
      this.fields.timeslots = this.getFieldSlots()
      slot.processing = false
    },
    async hold(slot) {
      const promises = []
      slot.processing = true
      try {
        promises.push(this.holdSlot(slot))
        const slots = this.numConsecutiveSlots || 1
        if (slots > 1) {
          let currentSlot = slot
          for(let i = 1; i < slots; ++i) {
            const nextSlot = this.slots[currentSlot.nextId]
            promises.push(this.holdSlot(nextSlot))
            currentSlot = nextSlot
          }
        }
        const holds = await Promise.all(promises)
        slot.participants = this.participants
        slot.holds = holds
        slot.selected = true
      } catch (e) {
        for(let hold of holds) {
          await this.unhold(hold)
        }
      }
      slot.processing = false
    },
    async holdSlot(slot) {
      const payload = {
        product_id: this.productId,
        start_at: slot.start_at,
        slots: this.participants,
        participants: this.participants,
        ...(slot.hold_payload || {})
      }
      const hold = await reservationHold(payload)
      return hold
    },
    async unhold(slot, noProgress) {
      const holds = _.cloneDeep(slot.holds || [])
      slot.selected = false
      slot.processing = !noProgress
      const promises = []
      for(let hold of holds) {
        promises.push(this.unholdSlot(hold))
      }
      if (!noProgress) {
        await Promise.all(promises)
      }
      slot.holds = null
      slot.processing = false
    },
    async unholdSlot(hold) {
      return await reservationUnHold(hold)
    },
    unholdSelectedSlots() {
      const slots = this.selectedSlots || {}
      _.forOwn(slots, slot => {
        this.unhold(slot, true)
      })
      this.fields.timeslots = this.getFieldSlots()
    },
    getFieldSlots() {
      const slots = this.selectedSlots || {}
      return _.mapValues(slots, slot => {
        /*
          selected: false,
          processing: false,
          disabled: false,
          valid: true,
          participants: 0,
          holds: null,
          nextId: null,
          prevId: null,
          id,
          datetime,
          time,
          timestamp,
         */
        return _.pick(slot, ['holds', 'participants', 'start_at', 'id', 'time', 'timestamp'])
      })
    },
    emit() {
      let value =  this.fields
      if (!value.start_at || !_.size(value.timeslots)) {
        value = null
      }
      this.$emit('input', value)
    }
  },
}
